import { gql } from '@apollo/client'

const publicTokenCategories = gql`
  query publicTokenCategories {
    publicTokenCategories {
      id
      name
      description
      fullDescription
      isPublished
      releaseDate
      slug
      tokens {
        id
        tokenId
        name
        nameShort
        slug
        description
        descriptionShort
        deadline
        imageUri
        isClaimed
        bonuses
        cardImageUri
        isLoopedPlayback
        isBiddingDisabled
        winningBid {
          amountInEth
          created
          creator {
            id
            username
            image
          }
        }
        bids {
          amountInEth
          created
          txHash
          creator {
            username
            image
          }
        }
        isBiddingDisabled
        project {
          id
          name
          creator {
            id
            username
            image
          }
          imageUri
        }
        url
        reservePriceInEth
        royaltiesInPercentage
        creator {
          username
          image
          name
          publicAddress
        }
        owner {
          username
          image
        }
        mintDate
        listDate
        claimDate
        videoUri
        videoPreviewUri
        avatarImageUri
      }
    }
  }
`

export default publicTokenCategories
